import { observer } from 'mobx-react-lite';
import {
    Redirect,
    Route,
    Switch,
    useLocation,
    useRouteMatch,
} from 'react-router-dom';
import { BasePage, PageType } from 'src/components/BasePage';
import { MetabasePageDetails } from 'src/pages/MetabasePage/MetabasePageDetails';
import { BasicStore } from 'src/utils/mobx/BasicStore/BasicStore';

export type MetabasePagePresentationProps = {
    store: BasicStore<any>;
    entityName: string;
};
export const MetabasePagePresentation = observer(
    ({ store, entityName }: MetabasePagePresentationProps) => {
        const { path } = useRouteMatch();
        const { pathname } = useLocation();

        return (
            <BasePage pageName={entityName} type={PageType.FULL}>
                <Switch>
                    <Route
                        path={`${path}/:entityId`}
                        exact
                        render={() => <MetabasePageDetails store={store} />}
                    />
                    {!pathname.match(/\d/) &&
                        Boolean(store?.list?.length > 0) && (
                            <Route
                                path={`${path}`}
                                exact
                                render={() => (
                                    <Redirect
                                        to={`${path}/${store?.list?.[0]?.id}`}
                                    />
                                )}
                            />
                        )}
                    <Route
                        path={`${path}/*`}
                        exact
                        render={() => <Redirect to={path} />}
                    />
                </Switch>
            </BasePage>
        );
    },
);
